import releases from './ros-dashboard-updates.json';
import type { RosDashboardRelease } from '@/entities/ros-updates/ros-update.entity';

const allReleases = releases as RosDashboardRelease[];

export function getRecentRosDashboardReleases(limit = 3): RosDashboardRelease[] {
  return allReleases.slice(0, limit);
}
